module.exports = __webpack_public_path__ + "img/1001980.0a2b1333.jpg";